import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/OkasBoxesView.css';  // Same Css for OkasBoxesView and SubscriptionView
import ErrorText from '../ErrorText';


//Subscription view page

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    // minHeight: '10%',
    // maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: 'white',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const SUbType = [  
// { label: 'Master Controller' },
// { label: 'VOD Box' },
// { label: 'UVOD Box' },
// { label: 'Audio Box' },
// { label: 'Home Theatre Box' },
];


export default class SubscriptionPlanView extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
    // SUbType: this.props.SUbCurrentData.okasBox_type,
    // ObSerialNo: this.props.ObCurrentData.okasBox_serialNo,
    // ObRegistrationId: this.props.SUbCurrentData.okasBox_serialNo,
    planName: this.props.SUbCurrentData.plan_name,
    fees: this.props.SUbCurrentData.fees,
    currency: this.props.SUbCurrentData.currency,
    feature1: this.props.SUbCurrentData.feature[0],
    feature2: this.props.SUbCurrentData.feature[1],
    // dateOfExpiry: this.props.SUbCurrentData.subscription_end_date,
    // email: this.props.SUbCurrentData.client_email,
    // paymentMobile: this.props.SUbCurrentData.payment_status,
    // ObLicenseId: this.props.SUbCurrentData.okasBox_version,
    errorMessage: [],
    modalIsOpenSuccess: false,
    showErrorMessage: false,
    SUbAvailable: true,
    publicVersion: []


  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.closeModalSuccess = this.closeModalSuccess.bind(this);

}

openModal() {
  this.setState({modalIsOpen: true});
}    
closeModalSuccess() {
  this.setState({
    modalIsOpenSuccess: false
  });
}

closeModalSuccess() {
  this.setState({
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpenSuccess: false
      })
    }, 500);

  })
}
afterOpenModal() {
  // references are now sync'd and can be accessed.
  // this.subtitle.style.color = '#f00';
}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.props.refreshDevices();
      this.setState({
        modalIsOpen: false
      })
    }, 500);

  })
}

onSelectChange = (operationMode, valueSelect) => {
  if (operationMode === 'subType') {
    this.setState({
      SUbType: valueSelect.value,
      errorMessage: []
    })
  } else if (operationMode === 'subVersion') {
    this.setState({
      ObLicenseId: valueSelect.value,
      errorMessage: []
    })
  }
}

componentDidMount(){
  // console.log('worked from dhuihdas')
    this.fecthAllSI();
    this.fetchPublicVersion()

}

fecthAllSI = ()=>{
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/plan/' ,{
          method: "GET",
          headers: headers,
      })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
    let subData = data.data;
  this.setState({
    subData: subData.data,
  },()=>console.log(this.state))
  console.log('subData:',subData)  
})

.catch((err)=>{
  console.log(err)

})
}



checkSUBSerialNo = (e) =>{
  let data = '';
  this.state.subData.forEach((e)=>{
    if(e.si_userName===this.state.ObRegistrationId){
    data = 'username exist';
    }
  })
  if(data==='username exist'){
    this.setState({
      SUBAvailable:false
    })
  }
}




handleChangeInputBox = (name, event) => {
  this.setState({
    [name]: event
  },()=>{
    if(name==='SUbSerialNo'){
      this.checkSUBSerialNo()
    }

  });
};

fetchPublicVersion = () => {
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
  }
  fetch('/cloud/subscriptionApi/', {
    method: "GET",
    headers: headers,
  })
             .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
    .then(data => {
      if (data.detail === 'Invalid token.') {
        console.log('Invalid token. Please log in again.');
        // localStorage.clear();
      } else {
        // console.log(data)
        let publicVersion = [];
        data.all_subscriptions.forEach((sumValue) => {
          publicVersion.push({ label: sumValue.id })
        })
        this.setState({ publicVersion })
      }
      console.log('sbData:',data.all_subscriptions)  //check
    })
    .catch((err)=>{
      console.log(err)
    })
}
  

  
    render(){
        return (
          <React.Fragment>
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen} 
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}} >VIEW PLAN</h3>
          <div className="row" style={{margin: '0px'}}>
         
             <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.planName}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="Plan Name:"
               inputBoxName="planName"
              //  handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div>  

             <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.fees}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="Fees:"
               inputBoxName="fees"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 

             <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.currency}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="Currency:"
               inputBoxName="currency"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 

             <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.feature1}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="Feature 1:"
               inputBoxName="subscriptionPlan"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div>  

             <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.feature2}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="Feature 2:"
               inputBoxName="feature2"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 
          
            </div>

            <div className="float-right" style={{marginTop: '70px', marginRight: '-15px' }}>
               <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>              
             </div>
            
        </Modal>
   
          </React.Fragment>
        );
    }
}
